export const lg_login = {
  login_th: {
    title: "เข้าสู่ระบบ",
    email: "อีเมล",
    email_place: "exam@email.com",
    password: "รหัสผ่าน",
    password_place: "รหัสผ่าน",
    btn_register: "ลงทะเบียน",
    btn_forgot: "ลืมรหัสผ่าน ?",
    btn_login: "เข้าสู่ระบบ",
    messageAlert: "อีเมล หรือ พาสเวิด ไม่ถูกต้อง กรุณาตรวจสอบข้อมูล",
    remember_me: "จดจำฉัน",
  },
  login_en: {
    title: "Login",
    email: "Email",
    email_place: "exam@email.com",
    password: "Password",
    password_place: "Password",
    btn_register: "Sign Up",
    btn_forgot: "Forgot Password?",
    btn_login: "Login",
    messageAlert:"Email or Password is incorrect, please check your information",
    remember_me: "Remember me",
  },
};
